import type { ActionConfig } from './types';

export const qaReportActions: ActionConfig[] = [
  // =============================================================================
  // RECORD ACTIONS
  // =============================================================================
  {
    id: 'qa-edit',
    name: 'Edit',
    icon: 'edit',
    table: 'qaReports',
    type: 'EDIT_RECORD',
    prominence: 'prominent',
    order: 1,
    config: {},
  },
  {
    id: 'qa-add',
    name: 'Add',
    icon: 'plus',
    table: 'qaReports',
    type: 'ADD_RECORD',
    prominence: 'prominent',
    order: 2,
    requiredViews: ['QA Views', 'Management Views'],
    config: {},
  },

  // =============================================================================
  // NAVIGATION ACTIONS
  // =============================================================================
  {
    id: 'qa-view-client',
    name: 'View Client',
    icon: 'chevron-circle-right',
    table: 'qaReports',
    type: 'NAVIGATE_APP',
    prominence: 'inline',
    order: 10,
    config: {
      route: '/clients/:clientId',
      params: { clientId: 'clientId' },
    },
  },

  // =============================================================================
  // EXPORT ACTIONS
  // =============================================================================
  {
    id: 'qa-download-pdf',
    name: 'Download PDF',
    icon: 'file-pdf',
    table: 'qaReports',
    type: 'EXPORT_VIEW',
    prominence: 'menu',
    order: 50,
    config: {
      filename: 'qa-report',
    },
  },
];
